import { useAuth0 } from "@auth0/auth0-react";
import { motion } from "framer-motion";

export default function Login() {
  const {
    loginWithRedirect,
    isAuthenticated,
    isLoading,
    user,
  } = useAuth0();

  // Loading State
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-black">
        <div className="text-white text-lg animate-pulse">
          Authenticating…
        </div>
      </div>
    );
  }

  // Already Logged In
  if (isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-black text-white">
        <div className="text-center space-y-3">
          <h1 className="text-2xl font-bold">
            Welcome back{user?.name ? `, ${user.name}` : ""}
          </h1>
          <p className="opacity-70">You are already logged in</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f0c29] via-[#302b63] to-[#24243e] px-4">
      
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="w-full max-w-md rounded-2xl bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl p-8 text-white"
      >
        <div className="text-center mb-8">
          <h1 className="text-3xl font-extrabold tracking-tight">
            Welcome Back
          </h1>
          <p className="mt-2 text-sm opacity-80">
            Sign in to continue to your workspace
          </p>
        </div>

        <motion.button
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          onClick={() =>
            loginWithRedirect({
              appState: { returnTo: "/dashboard" },
            })
          }
          className="w-full py-3 rounded-xl bg-pink-600 hover:bg-pink-700 font-semibold text-lg shadow-lg transition"
        >
          Continue with Auth0
        </motion.button>

        <div className="mt-6 text-center text-xs opacity-60">
          Secured authentication · OAuth 2.0 · OpenID Connect
        </div>
      </motion.div>
    </div>
  );
}
